import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const getCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.state === undefined) {
        throw new Error('Missing required parameter: state');
    }
    const path = '/api/ws-invoices/campaigns';
    const pathInternal = '/api/campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.state !== undefined) {
        urlParams.append('state', params.state.toString());
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaigns.paramsOrder = [{ type: 'parameters' }];
export const getInvoiceStateForSingleCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-invoices/campaign/invoice-state/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaign/invoice-state/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceStateForSingleCampaign.paramsOrder = [{ type: 'parameters' }];
export const getInvoiceStateForMultipleCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignIds === undefined) {
        throw new Error('Missing required body: campaignIds');
    }
    const path = '/api/ws-invoices/campaign/invoice-state-by-ids';
    const pathInternal = '/api/campaign/invoice-state-by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignIds !== undefined) {
        body = params.campaignIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceStateForMultipleCampaigns.paramsOrder = [{ type: 'body', paramName: 'campaignIds' }];
export const getSBInvoices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/invoices/self-booked';
    const pathInternal = '/api/invoices/self-booked';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSBInvoices.paramsOrder = [{ type: 'parameters' }];
export const getInvoices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/invoices';
    const pathInternal = '/api/invoices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.invoiceState : (params.invoiceState ?? queryDefaults?.['invoiceState']);
        if (value !== undefined) {
            urlParams.append('invoiceState', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.entityId : (params.entityId ?? queryDefaults?.['entityId']);
        if (value !== undefined) {
            urlParams.append('entityId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.campaignStartDateFrom
            : (params.campaignStartDateFrom ?? queryDefaults?.['campaignStartDateFrom']);
        if (value !== undefined) {
            urlParams.append('campaignStartDateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.campaignStartDateTo
            : (params.campaignStartDateTo ?? queryDefaults?.['campaignStartDateTo']);
        if (value !== undefined) {
            urlParams.append('campaignStartDateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.campaignCloseDateFrom
            : (params.campaignCloseDateFrom ?? queryDefaults?.['campaignCloseDateFrom']);
        if (value !== undefined) {
            urlParams.append('campaignCloseDateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.campaignCloseDateTo
            : (params.campaignCloseDateTo ?? queryDefaults?.['campaignCloseDateTo']);
        if (value !== undefined) {
            urlParams.append('campaignCloseDateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.invoicingAccountId
            : (params.invoicingAccountId ?? queryDefaults?.['invoicingAccountId']);
        if (value !== undefined) {
            urlParams.append('invoicingAccountId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.ownerId : (params.ownerId ?? queryDefaults?.['ownerId']);
        if (value !== undefined) {
            urlParams.append('ownerId', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.campaignPositionType
            : (params.campaignPositionType ?? queryDefaults?.['campaignPositionType']);
        if (value !== undefined) {
            urlParams.append('campaignPositionType', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.adMediumName : (params.adMediumName ?? queryDefaults?.['adMediumName']);
        if (value !== undefined) {
            urlParams.append('adMediumName', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.unpaidOnly : (params.unpaidOnly ?? queryDefaults?.['unpaidOnly']);
        if (value !== undefined) {
            urlParams.append('unpaidOnly', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.currency : (params.currency ?? queryDefaults?.['currency']);
        if (value !== undefined) {
            urlParams.append('currency', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoices.paramsOrder = [{ type: 'parameters' }];
export const getInvoiceById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceById.paramsOrder = [{ type: 'parameters' }];
export const getUnpaidInvoicesAmount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-invoices/unpaid-amount';
    const pathInternal = '/api/unpaid-amount';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUnpaidInvoicesAmount.paramsOrder = [{ type: 'parameters' }];
export const getCampaignById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.entityId === undefined) {
        throw new Error('Missing required parameter: entityId');
    }
    const path = '/api/ws-invoices/campaigns/{entityId}'.replace('{entityId}', params.entityId?.toString());
    const pathInternal = '/api/campaigns/{entityId}'.replace('{entityId}', params.entityId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignById.paramsOrder = [{ type: 'parameters' }];
export const createManualInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-invoices/campaigns/{campaignId}/invoices/create'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/invoices/create'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createManualInvoice.paramsOrder = [{ type: 'parameters' }];
export const checkIsValidInvoiceFileName = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.fileName === undefined) {
        throw new Error('Missing required parameter: fileName');
    }
    const path = '/api/ws-invoices/invoices/is-valid-file';
    const pathInternal = '/api/invoices/is-valid-file';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceId !== undefined) {
        urlParams.append('invoiceId', params.invoiceId.toString());
    }
    if (params.fileName !== undefined) {
        urlParams.append('fileName', params.fileName.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkIsValidInvoiceFileName.paramsOrder = [{ type: 'parameters' }];
export const approveInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/invoices/approve/{invoiceId}'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/approve/{invoiceId}'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
approveInvoice.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const resendPingenInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/pingen/resend'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/pingen/resend'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'text/plain';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
resendPingenInvoice.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const resendDigitalInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/digital/resend'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/digital/resend'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.orientationType : (params.orientationType ?? queryDefaults?.['orientationType']);
        if (value !== undefined) {
            urlParams.append('orientationType', value.toString());
        }
    }
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'text/plain';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
resendDigitalInvoice.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const isFileSentInPingen = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.fileName === undefined) {
        throw new Error('Missing required parameter: fileName');
    }
    const path = '/api/ws-invoices/invoices/pingen/sent/check';
    const pathInternal = '/api/invoices/pingen/sent/check';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.fileName !== undefined) {
        urlParams.append('fileName', params.fileName.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
isFileSentInPingen.paramsOrder = [{ type: 'parameters' }];
export const cancelInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/cancel'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/cancel'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceCancelForm !== undefined) {
        body = params.invoiceCancelForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cancelInvoice.paramsOrder = [{ type: 'body', paramName: 'invoiceCancelForm' }, { type: 'parameters' }];
export const editInvoiceCancellationDate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/cancellation-date'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/cancellation-date'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceCancelForm !== undefined) {
        body = params.invoiceCancelForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
editInvoiceCancellationDate.paramsOrder = [
    { type: 'body', paramName: 'invoiceCancelForm' },
    { type: 'parameters' },
];
export const reopenInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/reopen'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/reopen'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
reopenInvoice.paramsOrder = [{ type: 'parameters' }];
export const cancelAndReopenInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/cancel-and-reopen'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/cancel-and-reopen'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceCancelForm !== undefined) {
        body = params.invoiceCancelForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cancelAndReopenInvoice.paramsOrder = [
    { type: 'body', paramName: 'invoiceCancelForm' },
    { type: 'parameters' },
];
export const paidInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/paid'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/paid'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
paidInvoice.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const revertPaidInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/revert-paid'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/revert-paid'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
revertPaidInvoice.paramsOrder = [{ type: 'parameters' }];
export const archiveInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/archive'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/archive'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
archiveInvoice.paramsOrder = [{ type: 'parameters' }];
export const restoreInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/restore'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/restore'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
restoreInvoice.paramsOrder = [{ type: 'parameters' }];
export const remindPersonallyForInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/remind-personally'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/remind-personally'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
remindPersonallyForInvoice.paramsOrder = [{ type: 'parameters' }];
export const moveToCollectionReminderInvoiceState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/collection-reminder'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/collection-reminder'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
moveToCollectionReminderInvoiceState.paramsOrder = [{ type: 'parameters' }];
export const moveToBadDebtInvoiceState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/bad-debt'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/bad-debt'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
moveToBadDebtInvoiceState.paramsOrder = [{ type: 'parameters' }];
export const revertBadDebtInvoiceState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/revert-bad-debt'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/revert-bad-debt'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
revertBadDebtInvoiceState.paramsOrder = [{ type: 'parameters' }];
export const getEmailsByInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/emails'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/emails'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getEmailsByInvoice.paramsOrder = [{ type: 'parameters' }];
export const editInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.invoice === undefined) {
        throw new Error('Missing required body: invoice');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/edit'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/edit'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoice !== undefined) {
        body = params.invoice;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
editInvoice.paramsOrder = [{ type: 'body', paramName: 'invoice' }, { type: 'parameters' }];
export const editReminder = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.invoice === undefined) {
        throw new Error('Missing required body: invoice');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/edit-reminder'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/edit-reminder'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoice !== undefined) {
        body = params.invoice;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
editReminder.paramsOrder = [{ type: 'body', paramName: 'invoice' }, { type: 'parameters' }];
export const getChargedInvoiceIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.entityIds === undefined) {
        throw new Error('Missing required body: entityIds');
    }
    const path = '/api/ws-invoices/campaigns/by-entity-ids';
    const pathInternal = '/api/campaigns/by-entity-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.entityIds !== undefined) {
        body = params.entityIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getChargedInvoiceIds.paramsOrder = [{ type: 'body', paramName: 'entityIds' }];
export const exportInvoices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/invoices/export';
    const pathInternal = '/api/invoices/export';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
exportInvoices.paramsOrder = [];
export const exportRevenueRecognition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/invoices/export-revenue-recognition';
    const pathInternal = '/api/invoices/export-revenue-recognition';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
exportRevenueRecognition.paramsOrder = [];
export const retransmitInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/retransmit-to-sap'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/retransmit-to-sap'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
retransmitInvoice.paramsOrder = [{ type: 'parameters' }];
export const pushInvoiceToBexio = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.invoicePositionIds === undefined) {
        throw new Error('Missing required body: invoicePositionIds');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/bexio/push'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/bexio/push'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoicePositionIds !== undefined) {
        body = params.invoicePositionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
pushInvoiceToBexio.paramsOrder = [{ type: 'body', paramName: 'invoicePositionIds' }, { type: 'parameters' }];
export const downloadInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/download'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/download'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.withCoverSheet : (params.withCoverSheet ?? queryDefaults?.['withCoverSheet']);
        if (value !== undefined) {
            urlParams.append('withCoverSheet', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.orientationType : (params.orientationType ?? queryDefaults?.['orientationType']);
        if (value !== undefined) {
            urlParams.append('orientationType', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: {
            200: 'json',
            204: 'json',
        },
        requestType: 'json',
    });
};
downloadInvoice.paramsOrder = [{ type: 'parameters' }];
export const downloadInvoicePreview = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.invoicePositionIds === undefined) {
        throw new Error('Missing required body: invoicePositionIds');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/preview/download'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/preview/download'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoicePositionIds !== undefined) {
        body = params.invoicePositionIds;
    }
    {
        const value = queryDefaults === false ? params.orientationType : (params.orientationType ?? queryDefaults?.['orientationType']);
        if (value !== undefined) {
            urlParams.append('orientationType', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadInvoicePreview.paramsOrder = [
    { type: 'body', paramName: 'invoicePositionIds' },
    { type: 'parameters' },
];
export const generateInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/generate'.replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/invoices/{invoiceId}/generate'.replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.orientationType : (params.orientationType ?? queryDefaults?.['orientationType']);
        if (value !== undefined) {
            urlParams.append('orientationType', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateInvoice.paramsOrder = [{ type: 'parameters' }];
export const getDefaultEmailText = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.invoiceEmailDto === undefined) {
        throw new Error('Missing required body: invoiceEmailDto');
    }
    const path = '/api/ws-invoices/campaign/{campaignId}/email-text'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaign/{campaignId}/email-text'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceEmailDto !== undefined) {
        body = params.invoiceEmailDto;
    }
    const headers = {};
    headers['Accept'] = 'text/html';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getDefaultEmailText.paramsOrder = [{ type: 'body', paramName: 'invoiceEmailDto' }, { type: 'parameters' }];
export const getDefaultPostalAddress = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-invoices/campaign/{campaignId}/postal-address'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaign/{campaignId}/postal-address'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'text/plain';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getDefaultPostalAddress.paramsOrder = [{ type: 'parameters' }];
export const getNotPaidSBAmount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/campaigns/self-booked/notPaidAmount';
    const pathInternal = '/api/campaigns/self-booked/notPaidAmount';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getNotPaidSBAmount.paramsOrder = [];
export const retransmitInvoices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.invoiceIds === undefined) {
        throw new Error('Missing required body: invoiceIds');
    }
    const path = '/api/ws-invoices/campaigns/{campaignId}/retransmit-invoices'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/retransmit-invoices'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceIds !== undefined) {
        body = params.invoiceIds;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
retransmitInvoices.paramsOrder = [{ type: 'body', paramName: 'invoiceIds' }, { type: 'parameters' }];
export const checkCredit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/credit/check';
    const pathInternal = '/api/credit/check';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkCredit.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getCreditInfoByAccountIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountIds === undefined) {
        throw new Error('Missing required body: accountIds');
    }
    const path = '/api/ws-invoices/credit/accounts';
    const pathInternal = '/api/credit/accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIds !== undefined) {
        body = params.accountIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreditInfoByAccountIds.paramsOrder = [{ type: 'body', paramName: 'accountIds' }];
export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-invoices/accounts/replace-account-id';
    const pathInternal = '/api/accounts/replace-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
export const getPayments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentStatus === undefined) {
        throw new Error('Missing required parameter: paymentStatus');
    }
    const path = '/api/ws-invoices/payments/{paymentStatus}'.replace('{paymentStatus}', params.paymentStatus?.toString());
    const pathInternal = '/api/payments/{paymentStatus}'.replace('{paymentStatus}', params.paymentStatus?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateFrom : (params.dateFrom ?? queryDefaults?.['dateFrom']);
        if (value !== undefined) {
            urlParams.append('dateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateTo : (params.dateTo ?? queryDefaults?.['dateTo']);
        if (value !== undefined) {
            urlParams.append('dateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.isCredit : (params.isCredit ?? queryDefaults?.['isCredit']);
        if (value !== undefined) {
            urlParams.append('isCredit', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayments.paramsOrder = [{ type: 'parameters' }];
export const extractPaymentsFromFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/payments/from-file';
    const pathInternal = '/api/payments/from-file';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
extractPaymentsFromFile.paramsOrder = [{ type: 'formData' }];
export const uploadAndProcessPaymentFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/payments/upload-and-process-file';
    const pathInternal = '/api/payments/upload-and-process-file';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.content !== undefined) {
        formData.append('content', toCorrectFormDataValue(params.content));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadAndProcessPaymentFile.paramsOrder = [{ type: 'formData' }];
export const addAccountToPayment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/add-account/{accountId}'
        .replace('{paymentId}', params.paymentId?.toString())
        .replace('{accountId}', params.accountId?.toString());
    const pathInternal = '/api/payments/{paymentId}/add-account/{accountId}'
        .replace('{paymentId}', params.paymentId?.toString())
        .replace('{accountId}', params.accountId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addAccountToPayment.paramsOrder = [{ type: 'parameters' }];
export const removeAccountFromPayment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/remove-account'.replace('{paymentId}', params.paymentId?.toString());
    const pathInternal = '/api/payments/{paymentId}/remove-account'.replace('{paymentId}', params.paymentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeAccountFromPayment.paramsOrder = [{ type: 'parameters' }];
export const addInvoiceToPayment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/add-invoice/{invoiceId}'
        .replace('{paymentId}', params.paymentId?.toString())
        .replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/payments/{paymentId}/add-invoice/{invoiceId}'
        .replace('{paymentId}', params.paymentId?.toString())
        .replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addInvoiceToPayment.paramsOrder = [{ type: 'parameters' }];
export const removeInvoiceFromPayment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/remove-invoice/{invoiceId}'
        .replace('{paymentId}', params.paymentId?.toString())
        .replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/payments/{paymentId}/remove-invoice/{invoiceId}'
        .replace('{paymentId}', params.paymentId?.toString())
        .replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeInvoiceFromPayment.paramsOrder = [{ type: 'parameters' }];
export const markPaymentAsDone = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/mark-as-done'.replace('{paymentId}', params.paymentId?.toString());
    const pathInternal = '/api/payments/{paymentId}/mark-as-done'.replace('{paymentId}', params.paymentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
markPaymentAsDone.paramsOrder = [{ type: 'parameters' }];
export const markPaymentAsOpen = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/mark-as-open'.replace('{paymentId}', params.paymentId?.toString());
    const pathInternal = '/api/payments/{paymentId}/mark-as-open'.replace('{paymentId}', params.paymentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
markPaymentAsOpen.paramsOrder = [{ type: 'parameters' }];
export const linkPaymentFiles = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/payments/link-files';
    const pathInternal = '/api/payments/link-files';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
linkPaymentFiles.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const editPayment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    if (params.paymentForm === undefined) {
        throw new Error('Missing required body: paymentForm');
    }
    const path = '/api/ws-invoices/payments/{paymentId}'.replace('{paymentId}', params.paymentId?.toString());
    const pathInternal = '/api/payments/{paymentId}'.replace('{paymentId}', params.paymentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.paymentForm !== undefined) {
        body = params.paymentForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
editPayment.paramsOrder = [{ type: 'body', paramName: 'paymentForm' }, { type: 'parameters' }];
export const linkInvoiceFiles = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/invoices/link-files';
    const pathInternal = '/api/invoices/link-files';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
linkInvoiceFiles.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getCompanyConfigs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/company-configs';
    const pathInternal = '/api/company-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyConfigs.paramsOrder = [{ type: 'parameters' }];
export const createCompanyConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyConfigForm === undefined) {
        throw new Error('Missing required body: companyConfigForm');
    }
    const path = '/api/ws-invoices/company-configs';
    const pathInternal = '/api/company-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyConfigForm !== undefined) {
        body = params.companyConfigForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCompanyConfig.paramsOrder = [{ type: 'body', paramName: 'companyConfigForm' }];
export const getCompanyConfigById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyConfigId === undefined) {
        throw new Error('Missing required parameter: companyConfigId');
    }
    const path = '/api/ws-invoices/company-configs/{companyConfigId}'.replace('{companyConfigId}', params.companyConfigId?.toString());
    const pathInternal = '/api/company-configs/{companyConfigId}'.replace('{companyConfigId}', params.companyConfigId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyConfigById.paramsOrder = [{ type: 'parameters' }];
export const updateCompanyConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyConfigId === undefined) {
        throw new Error('Missing required parameter: companyConfigId');
    }
    if (params.companyConfigForm === undefined) {
        throw new Error('Missing required body: companyConfigForm');
    }
    const path = '/api/ws-invoices/company-configs/{companyConfigId}'.replace('{companyConfigId}', params.companyConfigId?.toString());
    const pathInternal = '/api/company-configs/{companyConfigId}'.replace('{companyConfigId}', params.companyConfigId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyConfigForm !== undefined) {
        body = params.companyConfigForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCompanyConfig.paramsOrder = [{ type: 'body', paramName: 'companyConfigForm' }, { type: 'parameters' }];
export const getCompanyConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/company-config';
    const pathInternal = '/api/company-config';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyConfig.paramsOrder = [];
export const isInvoiceReminderEnabled = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/company-config/invoice-reminder-enabled';
    const pathInternal = '/api/company-config/invoice-reminder-enabled';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
isInvoiceReminderEnabled.paramsOrder = [];
export const pingenWebhookCallback = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.incomingForm === undefined) {
        throw new Error('Missing required body: incomingForm');
    }
    const path = '/api/ws-invoices/pingen/webhookCallback';
    const pathInternal = '/api/pingen/webhookCallback';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.incomingForm !== undefined) {
        body = params.incomingForm;
    }
    const headers = {};
    headers['Accept'] = 'text/plain';
    headers['Content-Type'] = 'application/json, application/vnd.api+json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
pingenWebhookCallback.paramsOrder = [{ type: 'body', paramName: 'incomingForm' }, { type: 'parameters' }];
export const getCustomInvoiceIdRanges = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/custom-invoice-id-ranges';
    const pathInternal = '/api/custom-invoice-id-ranges';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCustomInvoiceIdRanges.paramsOrder = [{ type: 'parameters' }];
export const createCustomInvoiceIdRange = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/custom-invoice-id-ranges';
    const pathInternal = '/api/custom-invoice-id-ranges';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCustomInvoiceIdRange.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getCustomInvoiceIdRangeById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-invoices/custom-invoice-id-ranges/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/custom-invoice-id-ranges/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCustomInvoiceIdRangeById.paramsOrder = [{ type: 'parameters' }];
export const updateCustomInvoiceIdRange = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/custom-invoice-id-ranges/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/custom-invoice-id-ranges/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCustomInvoiceIdRange.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const getReportingInvoicePositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-invoices/reporting/invoice-positions';
    const pathInternal = '/api/reporting/invoice-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingInvoicePositions.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
